const CONTRIBUTE_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/contributeFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/contributeFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/contributeFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default CONTRIBUTE_FEATURE
